import { render } from "./msgCenter.vue?vue&type=template&id=0a0eef4b&scoped=true"
import script from "./msgCenter.vue?vue&type=script&lang=js"
export * from "./msgCenter.vue?vue&type=script&lang=js"

import "./msgCenter.vue?vue&type=style&index=0&id=0a0eef4b&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0eef4b"]])

export default __exports__